import { useSkipSessionActivityMutation } from '@innovamat/glow-api-client';
import { useUnityDataStore } from '../store/unity-data';
import { useUser } from '@innovamat/ga-features';
import { useNavigate } from 'react-router-dom';
import { storage } from '@innovamat/radiance-utils';

export function useUnityEvents() {
  const {
    unityData,
    updateTokens,
    overwriteState,
    updateBridgeIsReady,
    resetToAtlasBuild,
    resetUnityData,
  } = useUnityDataStore();

  const skipSessionActivity = useSkipSessionActivityMutation();

  const { onClearUserSession } = useUser();
  const navigate = useNavigate();
  const handleLogout = async () => {
    onClearUserSession();
    resetUnityData();
    localStorage.removeItem('sso_clicked');
    navigate('/', { replace: true });
  };

  const handleUnityEvents = (eventMessage: MessageEvent) => {
    const { data } = eventMessage;

    const isMessage = data?.eventId !== null && data?.eventId !== undefined;

    if (isMessage) {
      switch (data.eventId) {
        case 'BridgeIsReady':
        case 'SendReadyToBrowser':
          updateBridgeIsReady(true);
          break;
        case 'UpdateTokens':
          const { AccessToken, RefreshToken, IdToken } = data.arguments;
          const tokenData = {
            token_type: storage.tokenInfo.get()?.token_type || '',
            expires_in: storage.tokenInfo.get()?.expires_in || 0,
            id_token: IdToken,
            access_token: AccessToken,
            refresh_token: RefreshToken,
          };
          storage.tokenInfo.set(tokenData);
          updateTokens({
            AccessToken: AccessToken,
            RefreshToken: RefreshToken,
            IdToken: IdToken,
          });
          break;
        case 'SendData':
          overwriteState(data.arguments);
          break;
        case 'SendCompleteActivityEvent':
          const { sessionType } = unityData;
          const isQuiz = sessionType === 'Quiz';

          if (!isQuiz) {
            resetToAtlasBuild();
          }

          const { quizSessionEntity } = unityData;
          const activities = quizSessionEntity?.activitiesList;

          if (!activities || activities.length <= 1) {
            resetToAtlasBuild();
            return;
          }

          overwriteState({
            quizSessionEntity: {
              ...quizSessionEntity,
              activitiesList: activities.slice(1),
            },
            quizNextActivity: true,
          });
          break;
        case 'SendCloseAppToBrowser':
          resetToAtlasBuild();
          break;
        case 'ActivityExceptionCatch':
          const { sessionEntity, uuid, InitialMenu } = unityData;
          if (
            InitialMenu &&
            InitialMenu !== 'AppletLibrary' &&
            sessionEntity?.activities
          ) {
            skipSessionActivity.mutate(
              {
                body: {
                  userUuid: uuid,
                  sessionType: sessionEntity?.sessionType,
                  isSkippedByFenix: true,
                  codename: sessionEntity?.activities[0].codename,
                },
              },
              {
                onSettled: () => {
                  resetToAtlasBuild();
                },
              }
            );
          } else {
            resetToAtlasBuild();
          }
          break;
        case 'Logout':
          handleLogout();
          break;
        default:
          break;
      }
    }
  };

  return { handleUnityEvents, handleLogout };
}
